import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Newsletter from "./NewsLetter";
import { Link } from "react-router-dom";

const colorLogoImage = require("../assets/images/velvetLogo.png");

const socialLinks = [
  { id: 1, link: "#", icon: "lab la-facebook" },
  { id: 2, link: "https://wa.me/998996327070", icon: "lab la-whatsapp" },
  { id: 3, link: "#", icon: "lab la-twitter" },
  {
    id: 4,
    link: "https://t.me/+EJTyMYqdrLY5MWVi",
    icon: "lab la-telegram",
  },
  {
    id: 5,
    link: "https://www.instagram.com/velvet.store.uz/?hl=en",
    icon: "lab la-instagram",
  },
];

const Footer = () => {
  return (
    <>
      <footer className="sp-b">
        <Container>
          <Row>
            <Col lg={3} className="mb-lg-0 mb-5">
              {/* - Footer Info - */}
              <div className="footer-info">
                {/* - Footer Logo - */}
                <div className="footer-info-logo">
                  <img src={colorLogoImage} alt="color-logo" />
                </div>
                {/* - Footer Logo - */}

                <div className="footer-info-text my-4">
                  <p>
                    VELVET STORE - dunyoning eng mashhur brendlaridan sifatli poyabzallarni O'zbekistonga yetkazib beruvchi ishonchli hamkor.
                  </p>
                </div>
              </div>

              <div className="footer-social">
                <ul>
                  {(socialLinks || []).map((link) => (
                    <li key={link.id}>
                      <Link to={link.link}><i className={link.icon}></i></Link>
                    </li>
                  ))}
                </ul>
              </div>
              {/* - Footer Info - */}
            </Col>
            {/* - Footer Links - */}

            {/* - Newsletter Form - */}
            <Col lg={4} className="mb-lg-0 mb-5">
              {/* <Newsletter /> */}
            </Col>
            {/* - Newsletter Form - */}
          </Row>

          
        </Container>
      </footer>
    </>
  );
};

export default Footer;
